export { default } from './ExpandingTextArea';
